export default {
  data() {
    return {
      buttonContainerView: false
    }
  },
  methods: {
    toggleButtonContainer(bln) {
      if (typeof bln === 'boolean') this.buttonContainerView = bln
      else this.buttonContainerView = !this.buttonContainerView
    },
    onClickWindow(e) {
      if (!this.$el.contains(e.target)) this.toggleButtonContainer(false)
      else if (e.type === 'mousedown') this.toggleButtonContainer(true)
    },
  },
  mounted() {
    window.addEventListener('mousedown', this.onClickWindow)
    window.addEventListener('focusin', this.onClickWindow)
  },
  beforeDestroy() {
    window.removeEventListener('mousedown', this.onClickWindow)
    window.removeEventListener('focusin', this.onClickWindow)
  }
}